import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="pt-16 pb-10 px-6 md:px-16" style={{ backgroundColor: "#0073E5" }}>
      <div className="max-w-7xl mx-auto">
        {/* Top section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 pb-16 border-b border-white/20">
          {/* Left: CTA text */}
          <div>
            <p className="text-lg md:text-xl font-medium text-white/80 max-w-md leading-relaxed mb-8">
              Have an idea or a project in mind? Whether it&apos;s custom software, digital marketing, or IT consulting — we&apos;d love to hear it. Let&apos;s build something great together.
            </p>
            <Link
              onClick={() => window.scrollTo(0, 0)}
              to="/contact-us"
              className="inline-flex items-center gap-2 font-semibold px-7 py-3.5 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap text-sm text-black"
              style={{ backgroundColor: "#D4F419" }}
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#c2e010")}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#D4F419")}
            >
              Start a project
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Right: Nav links */}
          <div className="flex justify-start md:justify-end">
            <div className="grid grid-cols-2 gap-x-16 gap-y-2">
              <ul className="space-y-2">
                {[
                  { label: "About Us", to: "/about-us" },
                  { label: "Our Services", to: "/our-services" },
                  { label: "Our Products", to: "/our-products" },
                  { label: "Contact Us", to: "/contact-us" },
                ].map((item) => (
                  <li key={item.label}>
                    <Link to={item.to} className="text-sm text-white/70 hover:text-white hover:underline transition-colors cursor-pointer">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
              <ul className="space-y-2">
                {[
                  { label: "Terms of Use", to: "/terms-of-use" },
                  { label: "Privacy Policy", to: "/privacy-policy" },
                  { label: "Refund Policy", to: "/refund-policy" },
                ].map((item) => (
                  <li key={item.label}>
                    <Link to={item.to} className="text-sm text-white/70 hover:text-white hover:underline transition-colors cursor-pointer">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Contact section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 pt-16 pb-12 border-b border-white/20">
          <div>
            <h2 className="text-6xl md:text-8xl font-bold text-white leading-none">
              Say<br />
              <span
                className="underline decoration-8 underline-offset-4"
                style={{ textDecorationColor: "#D4F419" }}
              >
                Hello
              </span>
            </h2>
          </div>
          <div className="space-y-6 text-sm text-white/70 leading-relaxed">
            <div>
              <p className="font-bold text-white mb-1 text-base">London App Syndicate LTD</p>
              <p className="text-white/70">
                International House<br />
                22-28 Wood Street<br />
                Doncaster<br />
                England<br />
                DN1 3LW
              </p>
            </div>
            <div className="space-y-2">
              <a
                href="tel:+447520663996"
                className="flex items-center gap-2 text-white/70 hover:text-white transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-sm"></i>
                </div>
                +447520663996
              </a>
              <a
                href="mailto:support@londonappsco.com"
                className="flex items-center gap-2 text-white/70 hover:text-white transition-colors cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                support@londonappsco.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-8 text-sm text-white/50">
          <span>Copyright &copy; 2026 London App Syndicate LTD. All rights reserved.</span>
          <div className="flex items-center gap-6">
            <Link to="/terms-of-use" className="hover:text-white hover:underline transition-colors cursor-pointer">
              Terms of Use
            </Link>
            <Link to="/privacy-policy" className="hover:text-white hover:underline transition-colors cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="/refund-policy" className="hover:text-white hover:underline transition-colors cursor-pointer">
              Refund Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
